module.exports = __webpack_public_path__ + "static/media/bg.296a7b99.png";